import React, { memo, SVGProps } from 'react'

export const Eye = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 18.4397C16.6387 18.4397 19.3987 15.4992 20.6314 13.7453C21.3542 12.7171 21.313 11.3299 20.5325 10.3718C19.0666 8.57472 16.008 5.55936 12 5.55936C8.03521 5.55936 4.96417 8.568 3.48673 10.3603C2.69185 11.3242 2.65057 12.72 3.38689 13.7539C4.63105 15.503 7.40449 18.4378 12.001 18.4378L12 18.4397ZM4.59745 11.2781C5.91361 9.68064 8.62561 7.00032 12 7.00032C15.4128 7.00032 18.1123 9.68352 19.417 11.2829C19.7971 11.7494 19.8125 12.407 19.4534 12.9178C18.3811 14.4422 15.9878 16.9997 12 16.9997C8.04961 16.9997 5.64289 14.4442 4.56001 12.9206C4.20097 12.4166 4.21537 11.7408 4.59745 11.2781Z"
      fill="currentColor"
    />
    <path
      d="M12 15.8323C14.1494 15.8323 15.8323 14.1494 15.8323 12C15.8323 9.85056 14.1494 8.16768 12 8.16768C9.85057 8.16768 8.16769 9.85056 8.16769 12C8.16769 14.1494 9.85057 15.8323 12 15.8323ZM12 9.60768C13.3411 9.60768 14.3923 10.6589 14.3923 12C14.3923 13.3411 13.3411 14.3923 12 14.3923C10.6589 14.3923 9.60769 13.3411 9.60769 12C9.60769 10.6589 10.6589 9.60768 12 9.60768Z"
      fill="currentColor"
    />
  </svg>
))
